
import { Vue, Component, Prop } from 'vue-property-decorator'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'
import Authentication from '~/components/common/modals/authentication/Authentication.vue'
import ResetPassword from '~/components/common/modals/authentication/ResetPassword.vue'
import LogoMain from '~/components/common/LogoMain.vue'
import Icon from '~/components/common/icon/Icon.vue'

export interface AuthViewData {
  title: string;
  description: string;
  component?: object;
}

interface AuthViewDataList {
  [key: string]: AuthViewData;
}

@Component({
  name: 'ModalAuthentication',
  components: {
    CloseCrossCtrl,
    Authentication,
    LogoMain,
    ResetPassword,
    Icon
  }
})
export default class ModalAuthentication extends Vue {
  @Prop({ type: Function, default: () => {} }) success!: () => void
  @Prop({ type: Function, default: () => {} }) close!: () => void

  private views: AuthViewDataList = {
    authentication: {
      title: 'Sign in to ScholarshipOwl',
      description: 'Continue with the email address you use to sign in.',
      component: Authentication
    },
    resetPassword: {
      title: 'Forgot Your Password?',
      description: `Enter your email address below and we’ll send
        you instructions on how to reset your password.`,
      component: ResetPassword
    },
    resetSuccess: {
      title: 'Dear Student,',
      description: `We’ve sent you an email with a link to reset your password.<br />
        If it’s not in your inbox, please check your spam folder.`,
      component: ResetPassword
    }
  }

  private currentViewName = 'authentication'

  handleEscapeKey(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      window.history.pushState('', '', '/')
      window.location.reload()
    }
  }

  private get view(): AuthViewData {
    return this.views[this.currentViewName]
  }

  private setView(name: string) {
    if (!name) { return }

    this.currentViewName = name
  }

  private successHandler() {
    this.success()
    this.$emit('close')
    window.location.reload()
  }

  private closeHandler() {
    this.close()
    this.$emit('close')
  }
}
